import React from 'react';
import { Helmet } from 'react-helmet';
const ContactBanner = () => {
  return (
    <>
      <Helmet>
        <title>Contact us | Amizhth Techno Solutions</title>
      </Helmet>
      <div className="breatcome_area2 d-flex align-items-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breatcome_title"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactBanner;
